import { createFeatureSelector, createSelector } from "@ngrx/store";
import { buildLicenseEntity } from "@youm-front/license/utils/factory";
import { LICENSE_FEATURE_KEY, LicenseState } from "../reducers";

const licenseState = createFeatureSelector<LicenseState>(LICENSE_FEATURE_KEY);

export const license = createSelector(licenseState, (state: LicenseState) => {
  if (!state.license) {
    return state.license;
  }

  return buildLicenseEntity(state.license);
});

export const isLoading = createSelector(licenseState, (state) => {
  return state.isLoading;
});
